import { useState } from 'react';
import { get } from 'lodash';
import { ajaxExceptionMessage } from '@skunexus/utils';

export function useRepushProducts({ mutation, successNotification = () => {}, errorNotification = () => {} }) {
    const [repushProductsModalData, setRepushProductsModalData] = useState({
        isOpen: false,
        products: [],
    });
    const [isPending, setIsPending] = useState(false);

    const handleCloseRepushProductsModal = () => {
        setRepushProductsModalData((prev) => ({ ...prev, isOpen: false, products: [] }));
    };

    const handleOpenRepushProductsModal = (products) => {
        setRepushProductsModalData((prev) => ({ ...prev, isOpen: true, products }));
    };

    const handleRepushProducts = async (products) => {
        setIsPending(true);
        try {
            await mutation({ productsIds: products.map((product) => product.id) });
            successNotification('Products repushed successfully.');
            handleCloseRepushProductsModal();
        } catch (error) {
            errorNotification(ajaxExceptionMessage(error));
        } finally {
            setIsPending(false);
        }
    };

    return [
        {
            repushProductsModalProps: {
                headerLabel: 'Confirm Products to repush',
                isOpen: repushProductsModalData.isOpen,
                isLoading: isPending,
                products: repushProductsModalData.products,

                onClose: handleCloseRepushProductsModal,
                onConfirm: handleRepushProducts,
            },
        },
        { handleOpenRepushProductsModal },
    ];
}
